import React from 'react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import classes from './Exercise.module.css';

const exercise = (props) => {
    // console.log('SELECTED: ',props.selected);
    let header_icon = '';
    if (props.selected === 'NewExerciseList') {
        header_icon = (<div className={classes.AddCircle}><AddCircleOutlineIcon style={{color: 'green'}} fontSize={"large"}/></div>);
    }


    // <div className="card-body">
    //     <div className={"cardText "+classes.truncate}>{props.description}</div>
    // </div>

    return (
        <div className={"card "+ classes.Exercise +" "+props.selected} onClick={props.clicked}>
            <h4 className="card-header">{props.name} {header_icon}</h4>
        </div>
    );
};

export default exercise;